/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Quick_Product_HintInputs */

const vi_order_quick_product_hint = /** @type {(inputs: Order_Quick_Product_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập tên sản phẩm và số lượng. Kế toán sẽ hoàn tất chi tiết.`)
};

/**

* @param {Order_Quick_Product_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_quick_product_hint = /** @type {((inputs?: Order_Quick_Product_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Quick_Product_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_quick_product_hint(inputs)
});